/**

 * Technology hub tab definitions — single source for nav labels, paths, and active matching.

 */

export const TECHNOLOGY_BASE = '/portal/technology';



export const TECHNOLOGY_TABS = [

  { id: 'all', label: 'All', path: 'all', emoji: '📋' },

  { id: 'agents', label: 'Agents', path: 'agents', emoji: '🤖' },

  { id: 'jobtread-imports', label: 'JobTread Imports', path: 'jobtread-imports', emoji: '📥', matchPaths: ['jobtread-imports', 'cost-groups', 'schedules', 'dashboards', 'todos'] },

  { id: 'claude-skills', label: 'Skills', path: 'claude-skills', emoji: '✨' },

  { id: 'automation', label: 'Automation', path: 'automation', emoji: '⚡' },

  { id: 'goals', label: 'Goals', path: 'goals', emoji: '🎯', hiddenInNav: true },

  { id: 'tech-stack', label: 'Tech Stack', path: 'tech-stack', emoji: '🖥️', matchPaths: ['tech-stack', 'all-software', 'software'] },


  { id: 'receptionist', label: 'AI Receptionist', path: 'receptionist', hiddenInNav: true },

  { id: 'estimating-template', label: 'Estimating Template', path: 'estimating-template', hiddenInNav: true },

  { id: 'chatbot', label: 'AI Chatbot', path: 'chatbot', hiddenInNav: true },

  { id: 'jtformulas', label: 'JobTread Formulas', path: 'jtformulas', hiddenInNav: true },

  { id: 'cost-groups', label: 'Cost Groups', path: 'cost-groups', matchPaths: ['cost-groups', 'estimating-template'], hiddenInNav: true },

  { id: 'schedules', label: 'Schedules', path: 'schedules', hiddenInNav: true },

  { id: 'dashboards', label: 'Dashboards', path: 'dashboards', hiddenInNav: true },

  { id: 'todos', label: 'To-Dos', path: 'todos', hiddenInNav: true },

  { id: 'workflows', label: 'Workflows', path: 'workflows', hiddenInNav: true },

];



/** Tabs shown in the Technology hub nav (hiddenInNav routes remain reachable by URL). */

export const TECHNOLOGY_NAV_TABS = TECHNOLOGY_TABS.filter((tab) => !tab.hiddenInNav);



export const DEFAULT_TECHNOLOGY_TAB = 'all';



/**

 * Resolve which tab is active from the current pathname.

 * @param {string} pathname - e.g. /portal/technology/automation

 */

export function getActiveTechnologyTabId(pathname) {

  if (!pathname?.startsWith(TECHNOLOGY_BASE)) {

    return DEFAULT_TECHNOLOGY_TAB;

  }



  const remainder = pathname.slice(TECHNOLOGY_BASE.length).replace(/^\//, '');

  if (!remainder) {

    return DEFAULT_TECHNOLOGY_TAB;

  }



  const firstSegment = remainder.split('/')[0];



  for (const tab of TECHNOLOGY_TABS) {

    const paths = tab.matchPaths || [tab.path];

    if (paths.some((p) => firstSegment === p || remainder.startsWith(`${p}/`))) {

      return tab.id;

    }

  }



  return DEFAULT_TECHNOLOGY_TAB;

}



export function getTechnologyTabHref(tab) {

  if (tab.path === '' || tab.id === 'all') {

    return `${TECHNOLOGY_BASE}/all`;

  }

  return `${TECHNOLOGY_BASE}/${tab.path}`;

}

